<div class="content-container">
  <p class="prompt-text">{{ prompt }}</p>
  <app-password-input
    [label]="label"
    [control]="password"
    placeholder="Enter password"
    (keyup)="handleKeyUp($event)"
  >
  </app-password-input>

  <div>
    <span *ngIf="hasError" class="error-msg">{{ error }}</span>
  </div>
</div>
<div class="button-container">
  <button pButton pRipple (click)="onCancel()">{{ cancelButtonLabel }}</button>
  <button pButton pRipple (click)="onVerify()">{{ verifyButtonLabel }}</button>
</div>
